export default __webpack_public_path__ + "59d86078ff3674ad35d516579bb99a84.png";